export default __webpack_public_path__ + "static/bg_image_blue-83cc25c45e652807f20594ebf5934603.webp";